<template>
    <div class="widget widget-product card blogs" v-if="productReviews != '' && productReviews != null">
        <header class="card-header">
            <h3 class="card-title">
                <span> تجربه خرید مشتریان </span>
            </h3>
           
        </header>
        <div class="product-reviews owl-carousel owl-theme">
            <div style="position:relative" class="item  discount-box" v-for="(productReview,index) in productReviews">
                <div>
                    <div class="star-str">
                        <span class="fa fa-star checked"></span>
                        <span class="fa fa-star checked"></span>
                        <span class="fa fa-star checked"></span>
                        <span class="fa fa-star checked"></span>
                        <span class="fa fa-star checked"></span>
                    </div>
                    <p class="txt-rew">
                        {{productReview.Text }}
                    </p>
                    <div class="date-cus">
                        <span> {{productReview.CustomerName }}</span>
                        <span>( {{productReview.RegDateTime }} ) </span>
                    </div>
                    <div class="avator">
                        <img v-if="productReview.CustomerPicPath != null" :src="productReview.CustomerPicPath" class="img-fluid" alt="ایران سکه"  @error="imageLoadOnError">
                        <img  v-if="productReview.CustomerPicPath == null" src="../../../public/assets/img/default-avatar.png" />
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>


<script>
    export default {
        data() {
            return {
                url: 'https://blog.irsekkeh.com'
            }
        },
        computed: {
            productReviews: function () {
                return this.$store.getters.readProductReviews;
            },

        },
        methods: {
            imageLoadOnError(event) {
                event.target.src = "/assets/img/no-slider-image-available.png";
            },
        }
    }
</script>

<style scoped>
    .product-reviews .item{
        text-align:center;
    }
    .star-str .checked {
        color: orange;
    }
    .txt-rew {
        padding: 2px 25px 0px 25px;
        display: block;
    }
    .txt-rew p{
        color:#444;
        
        text-align: justify;
        font-size: 13px;
    }
    .date-cus {
        margin : 12px 12px 12px 12px;
    }
    .date-cus span {
        display: inline-block;
        font-size: 12px;
        color: #a6a6a6;
    }
    .avator   {
    display : flex;
    justify-content:center;
    align-items:center;
    }
    .avator img {
        width:50px;
    }
    .blogs .product-carousel .item .post-title {
        height: auto;
        text-align: right;
        margin-right: 18px;
        margin-bottom: 0;
    }

    .blogs .discount-box .discount {
        top: 20px;
        right: 25px;
        background-color: #ea8f97;
        padding-left: 10px;
        padding-right: 10px;
        width: fit-content;
        font-size: 15px;
    }

    .call {
        font-size: 13px;
    }

    .unAvailable {
        font-size: 14px;
    }

    .discount-box {
        position: relative;
    }

        .discount-box .discount {
            content: '';
            width: 55px;
            height: 35px;
            background-color: #ef5662;
            color: #fff;
            top: 20px;
            left: 15px;
            position: absolute;
            display: flex;
            justify-content: center;
            align-items: center;
            font-weight: bold;
            border-radius: 40px;
            z-index: 9999;
            font-size: 16px;
        }

    @media only screen and (min-width: 0px) and (max-width: 640px) {
        .discount-box .discount {
            width: 44px;
            height: 25px;
            top: 7px;
            left: 1px;
            font-size: 13px;
        }

        .widget-blog .blog-carousel .item .price del, .brand-slider .blog-carousel .item .price del {
            color: #979898;
            font-size: 13px;
        }

        .widget-blog .blog-carousel .item ins, .brand-slider .blog-carousel .item ins {
            color: #ef5661;
            font-size: 13px;
        }
    }

    @media only screen and (min-width: 641px) and (max-width: 640px) {
        .widget-blog .blog-carousel .item .price del, .brand-slider .blog-carousel .item .price del {
            color: #979898;
            font-size: 13px;
        }
    }
</style>